import { UserConstants } from '../constants';
import { UserAction } from '../actions/types';

export const initialState: STATES.AnonymousUserState = {
  isLoading: false,
  user_id: '',
  link_id: '',
  link_url: '',
  isOtpSentSuccess: false,
  redirectUrl: '',
  error: '',
  anonymousToken: '',
};

export const anonymousUser = (
  state = initialState,
  action: UserAction
): STATES.AnonymousUserState => {
  switch (action.type) {
    case UserConstants.CREATE_ANONYMOUS_REQUEST: {
      return {
        ...initialState,
        isLoading: true,
      };
    }
    case UserConstants.CREATE_ANONYMOUS_USER_SUCCESS: {
      const { userId } = action.payload;
      return {
        ...state,
        isLoading: false,
        user_id: userId,
      };
    }
    case UserConstants.CREATE_ANONYMOUS_FAILURE: {
      const { error } = action.payload;
      return {
        ...initialState,
        error: error ?? '',
      };
    }
    case UserConstants.CREATE_ANONYMOUS_LINK_SUCCESS: {
      const { linkId, linkUrl } = action.payload;
      return {
        ...state,
        isLoading: false,
        link_id: linkId,
        link_url: linkUrl,
      };
    }
    case UserConstants.SEND_KEYCLOAK_OTP_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isOtpSentSuccess: true,
      };
    }
    case UserConstants.GENERATE_KEYCLOAK_ANONYMOUS_TOKEN_SUCCESS: {
      const { redirectUrl, anonymousToken } = action.payload;
      return {
        ...state,
        isLoading: false,
        redirectUrl,
        anonymousToken,
      };
    }
    default:
      return state;
  }
};
